import React, { FC } from 'react'
import { Grid } from '@mui/material'
import { CollapsibleSection, HasSidebarLayout, ListHeader, SensorConfigurationAnalyticsSummarySection, SensorConfigurationSensorsTable } from 'src/components'

const SensorConfigurationAnalyticsListPage: FC = () => {
  document.title = 'CLīMIT Admin Panel - Sensor Configuration Analytics'
  return (
    <HasSidebarLayout>
      <ListHeader title="Sensor Configuration Analytics" />
      <Grid container spacing={2} direction="column" wrap="nowrap">
        <Grid item xs={12}>
          <CollapsibleSection title="Configuration Summary" defaultExpanded>
            <SensorConfigurationAnalyticsSummarySection />
          </CollapsibleSection>
        </Grid>
        <Grid item xs={12}>
          <CollapsibleSection title="Sensors">
            <SensorConfigurationSensorsTable />
          </CollapsibleSection>
        </Grid>
      </Grid>
    </HasSidebarLayout>
  )
}

export default SensorConfigurationAnalyticsListPage
